export const GET_STAFF_LIST_REQUEST = 'GET_STAFF_LIST_REQUEST';
export const GET_STAFF_LIST_SUCCESS = 'GET_STAFF_LIST_SUCCESS';
export const GET_STAFF_LIST_FAILURE = 'GET_STAFF_LIST_FAILURE';

export const GET_EXPORT_STAFF_REQUEST = 'GET_EXPORT_STAFF_REQUEST';
export const GET_EXPORT_STAFF_SUCCESS = 'GET_EXPORT_STAFF_SUCCESS';
export const GET_EXPORT_STAFF_FAILURE = 'GET_EXPORT_STAFF_FAILURE';
export const CLEAR_EXPORT_STAFF_STATE = 'CLEAR_EXPORT_STAFF_STATE';
